import React from 'react';
import { useDidMount } from 'rooks';
import { SummaryReportViewer, SummaryReportViewerProps } from '@/summaryReport/summaryReportViewer.organism';

export interface SummaryReportViewerContentProps extends SummaryReportViewerProps {
  onContentLoad: () => void;
}

/**
 * Summary Report Viewer content component for rendering in topic documents.
 */
export const SummaryReportViewerContent: React.FunctionComponent<SummaryReportViewerContentProps> = (props) => {
  const { onContentLoad } = props;

  useDidMount(() => onContentLoad());

  return <SummaryReportViewer {...props} />;
};
